module.exports = __webpack_public_path__ + "img/HDFC_health.aad65a2b.png";